<div class="settings">

  <!-- Page header -->
  <header class="settings-header animate-fade-in">
    <div>
      <div class="settings-header__title-row">
        <h2 class="settings-title">Configuración avanzada</h2>
        <span class="pro-badge">
          <span class="material-symbols-outlined" style="font-size:.7rem; font-variation-settings:'FILL' 1;">crown</span>
          PRO
        </span>
      </div>
      <p class="settings-subtitle">Monetización, branding y flujos de comunicación.</p>
    </div>
  </header>

  <!-- Analytics strip (peak-end: empezar con algo positivo) -->
  <div class="analytics-strip animate-fade-in delay-1">
    <div class="analytic-card">
      <div class="analytic-card__icon" style="background: rgba(186,26,26,0.08); color: var(--error);">
        <span class="material-symbols-outlined" style="font-variation-settings:'FILL' 1;">event_busy</span>
      </div>
      <div>
        <p class="analytic-card__label">Tasa de cancelación</p>
        <div class="analytic-card__value-row">
          <span class="analytic-card__value">3.2%</span>
          <span class="analytic-card__delta analytic-card__delta--down">
            <span class="material-symbols-outlined" style="font-size:.75rem">arrow_downward</span> 12%
          </span>
        </div>
      </div>
    </div>
    <div class="analytic-card">
      <div class="analytic-card__icon" style="background: rgba(0,84,204,0.08); color: var(--primary);">
        <span class="material-symbols-outlined" style="font-variation-settings:'FILL' 1;">payments</span>
      </div>
      <div>
        <p class="analytic-card__label">Ingresos estimados</p>
        <div class="analytic-card__value-row">
          <span class="analytic-card__value">$14.280</span>
          <span class="analytic-card__delta analytic-card__delta--up">este mes</span>
        </div>
      </div>
    </div>
    <div class="analytic-card">
      <div class="analytic-card__icon" style="background: var(--tertiary-fixed); color: var(--tertiary);">
        <span class="material-symbols-outlined" style="font-variation-settings:'FILL' 1;">trending_up</span>
      </div>
      <div>
        <p class="analytic-card__label">Días más activos</p>
        <div class="analytic-card__value-row">
          <span class="analytic-card__value">Mar / Jue</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Main config grid -->
  <div class="config-grid">

    <!-- Left column -->
    <div class="config-col animate-fade-in delay-2">

      <!-- Monetization -->
      <section class="config-section card">
        <div class="config-section__header">
          <div>
            <h3 class="config-section__title">Motor de monetización</h3>
            <p class="config-section__desc">Conectá pasarelas de pago y gestioná transacciones.</p>
          </div>
          <span class="material-symbols-outlined" style="color: var(--primary); font-size: 1.75rem;">currency_exchange</span>
        </div>

        <div class="payment-integrations">
          <div class="integration-row integration-row--active">
            <div class="integration-logo integration-logo--stripe">Stripe</div>
            <div class="integration-info">
              <p class="integration-name">Stripe Integration</p>
              <p class="integration-desc">Cobros instantáneos y procesamiento de tarjetas</p>
            </div>
            <label class="toggle">
              <input type="checkbox" checked />
              <span class="toggler"></span>
            </label>
          </div>
          <div class="integration-row">
            <div class="integration-logo integration-logo--paypal">PayPal</div>
            <div class="integration-info">
              <p class="integration-name">PayPal Checkout</p>
              <p class="integration-desc">Pagos con billetera digital</p>
            </div>
            <label class="toggle">
              <input type="checkbox" />
              <span class="toggler"></span>
            </label>
          </div>
          <div class="integration-row">
            <div class="integration-logo integration-logo--mp">MP</div>
            <div class="integration-info">
              <p class="integration-name">Mercado Pago</p>
              <p class="integration-desc">Pasarela regional para LatAm</p>
            </div>
            <label class="toggle">
              <input type="checkbox" />
              <span class="toggler"></span>
            </label>
          </div>
        </div>
      </section>

      <!-- White label branding -->
      <section class="config-section card">
        <h3 class="config-section__title">Identidad White Label</h3>

        <div class="branding-grid">
          <div class="upload-area">
            <span class="material-symbols-outlined" style="color: var(--primary); font-size: 2rem;">upload_file</span>
            <p>Subir logo de negocio</p>
            <span class="upload-hint">SVG, PNG o JPG (máx. 2MB)</span>
          </div>
          <div class="branding-inputs">
            <div class="form-group">
              <label class="form-label">Dominio personalizado</label>
              <div class="domain-input">
                <span class="domain-prefix">https://</span>
                <input class="input-field" type="text" placeholder="turnos.minegocio.com" />
              </div>
              <p class="domain-hint">El certificado SSL se genera automáticamente.</p>
            </div>
            <button class="btn-primary" style="width:100%">Guardar cambios</button>
          </div>
        </div>
      </section>

    </div>

    <!-- Right column -->
    <div class="config-col animate-fade-in delay-3">

      <!-- Communication workflows -->
      <section class="config-section card">
        <div class="workflow-header">
          <div class="workflow-icon">
            <span class="material-symbols-outlined" style="font-variation-settings:'FILL' 1;">forum</span>
          </div>
          <h3 class="config-section__title">Flujos de comunicación</h3>
        </div>

        <div class="workflow-list">
          <div class="workflow-item workflow-item--active">
            <div class="workflow-item__header">
              <div class="workflow-item__name">
                <span class="material-symbols-outlined" style="color: #25d366;">chat</span>
                <span>WhatsApp</span>
              </div>
              <span class="status-pill status-pill--live">En vivo</span>
            </div>
            <p class="workflow-item__desc">Recordatorios automáticos 2 horas antes del turno.</p>
            <button class="text-link">Editar plantilla</button>
          </div>

          <div class="workflow-item workflow-item--inactive">
            <div class="workflow-item__header">
              <div class="workflow-item__name">
                <span class="material-symbols-outlined" style="color: var(--primary);">sms</span>
                <span>SMS</span>
              </div>
              <span class="status-pill">Inactivo</span>
            </div>
            <p class="workflow-item__desc">Envío de SMS internacional para clientes remotos.</p>
            <button class="text-link">Configurar</button>
          </div>
        </div>
      </section>

      <!-- Resources -->
      <section class="config-section card">
        <div class="resources-header">
          <h3 class="config-section__title">Recursos</h3>
          <button class="add-resource-btn">
            <span class="material-symbols-outlined">add</span>
          </button>
        </div>

        <div class="resource-list">
          <div class="resource-item">
            <div class="resource-thumbnail resource-thumbnail--img">
              <span class="material-symbols-outlined">meeting_room</span>
            </div>
            <div class="resource-info">
              <p class="resource-name">Consultorio A</p>
              <p class="resource-type">Espacio físico</p>
            </div>
            <span class="resource-status resource-status--green"></span>
          </div>
          <div class="resource-item">
            <div class="resource-thumbnail resource-thumbnail--img">
              <span class="material-symbols-outlined">precision_manufacturing</span>
            </div>
            <div class="resource-info">
              <p class="resource-name">Equipo Láser</p>
              <p class="resource-type">Equipamiento</p>
            </div>
            <span class="resource-status resource-status--amber"></span>
          </div>
          <div class="resource-item">
            <div class="resource-thumbnail">
              <span class="material-symbols-outlined" style="color: var(--primary);">person</span>
            </div>
            <div class="resource-info">
              <p class="resource-name">Elena Rossi</p>
              <p class="resource-type">Arquitecta líder</p>
            </div>
            <span class="resource-status resource-status--green"></span>
          </div>
        </div>

        <!-- Goal-gradient: límite de recursos PRO -->
        <div class="resource-limit">
          <div class="resource-limit__text">
            <span class="text-muted">Límite PRO de recursos</span>
            <span style="font-family: var(--font-headline); font-weight: 700; color: var(--tertiary); font-size: 0.8125rem;">8 / 15</span>
          </div>
          <div class="resource-limit__track">
            <div class="resource-limit__fill" style="width: 53%"></div>
          </div>
        </div>
      </section>

    </div>
  </div>

  <!-- Appearance -->
  <section class="config-section card appearance-section animate-fade-in" style="margin-top: var(--space-6);">
    <div class="config-section__header">
      <div>
        <h3 class="config-section__title">Apariencia</h3>
        <p class="config-section__desc">Elegí entre modo claro y oscuro según tu preferencia.</p>
      </div>
      <span class="material-symbols-outlined" style="color: var(--primary); font-size: 1.75rem;">contrast</span>
    </div>

    <div class="theme-toggle-row">
      <div class="theme-option" [class.theme-option--active]="!theme.isDark" (click)="theme.isDark && theme.toggle()">
        <span class="material-symbols-outlined">light_mode</span>
        <span>Modo claro</span>
      </div>
      <label class="toggle" style="flex-shrink:0">
        <input type="checkbox" [checked]="theme.isDark" (change)="theme.toggle()" />
        <span class="toggler"></span>
      </label>
      <div class="theme-option" [class.theme-option--active]="theme.isDark" (click)="!theme.isDark && theme.toggle()">
        <span class="material-symbols-outlined">dark_mode</span>
        <span>Modo oscuro</span>
      </div>
    </div>
  </section>

</div>
